import { render, staticRenderFns } from "./settingPassword.vue?vue&type=template&id=01042b09&scoped=true"
import script from "./settingPassword.vue?vue&type=script&lang=js"
export * from "./settingPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01042b09",
  null
  
)

export default component.exports